import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimilarFundraiserComponent } from './components/similar-fundraiser/similar-fundraiser.component';
import { WidgetModule } from '../widget/widget.module';
import { NgxGlideModule } from 'ngx-glide';

@NgModule({
  declarations: [SimilarFundraiserComponent],
  exports: [SimilarFundraiserComponent],
  imports: [
    CommonModule,
    WidgetModule,
    NgxGlideModule
  ]
})
export class SimilarFundraiserModule { }
